import { config } from "../config";
import { parseDestination } from "./destination-validation";
export type { DestinationConfig } from "./destination-validation";

export async function loadDestination(signal: AbortSignal) {
  const endpoint = config.pwaConfigUrl;
  const response = await fetch(endpoint, {
    signal,
    cache: "no-store",
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  if (!response.ok)
    throw new Error(`Configuration unavailable (${response.status}).`);
  if (!response.headers.get("content-type")?.includes("application/json")) {
    throw new Error("The configuration service is not connected yet.");
  }
  return parseDestination(await response.json(), {
    environment: config.environment,
    origin: location.origin,
    videoSiteOrigin: config.videoSiteOrigin,
  });
}
